"use client";

import { Mail, Phone, Facebook, Instagram, Linkedin, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
export default function Footer() {
  return <section id="footer" className="bg-background text-foreground">
      {}
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
          {}
          <div className="flex flex-col gap-4">
            
            <div className="text-sm font-default text-muted-foreground">
              <p>Yonge Sheppard RMT &amp; Facial Wellness<br />1 Elmhurst Ave, North York, ON M2N 1R3</p>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-default font-semibold text-foreground">Contact</h3>
            <div className="flex flex-col gap-3 text-sm font-default">
              <div className="flex items-center gap-2 text-foreground">
                <Mail className="size-4" />
                <Link to="mailto:hello@yswellness.ca" className="hover:text-primary transition-colors">
                  hello@yswellness.ca
                </Link>
              </div>
              <div className="flex items-center gap-2 text-foreground">
                <Phone className="size-4" />
                <Link to="tel:416-938-9900" className="hover:text-primary transition-colors">
                  416-938-9900
                </Link>
              </div>
            </div>
            <Button asChild className="mt-2 w-full bg-primary text-primary-foreground hover:bg-primary/90">
              <Link to="https://yswellness.noterro.com">Book Now</Link>
            </Button>

            {}
            <div className="mt-4 flex flex-col gap-2">
              <div className="flex items-center gap-2">
                <div className="inline-flex items-center rounded-lg border border-border bg-accent px-2.5 py-0.5 text-xs font-semibold text-accent-foreground transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
                  <Star className="mr-1 size-3 fill-current text-yellow-500" />
                  4.8 Google Reviews
                </div>
              </div>
              <p className="text-xs text-muted-foreground">
                Trusted by hundreds of clients in North York for premium wellness care.
              </p>
            </div>
          </div>
        </div>
      </div>

      {}
      <Separator className="bg-border" />

      {}
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          <p className="text-xs font-default text-muted-foreground">© 2026 Yonge Sheppard RMT &amp; Facial Wellness. All rights reserved.</p>
          <div className="flex gap-4">
            <Link to="https://facebook.com" newTab className="text-muted-foreground hover:text-foreground transition-colors" aria-label="Facebook">
              <Facebook className="size-5" />
            </Link>
            <Link to="https://instagram.com" newTab className="text-muted-foreground hover:text-foreground transition-colors" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
            <Link to="https://linkedin.com" newTab className="text-muted-foreground hover:text-foreground transition-colors" aria-label="LinkedIn">
              <Linkedin className="size-5" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}